import { css } from 'emotion'
// import { PRIMARY_COLOR, PRIMARY_COLOR_DARK } from 'constants/styleConstants'

export const RemoveTagButtonStyles = css``
